// Messages where the sender is Game and the receiver is Launcher
export enum FromGamePostMessage {
  PgReload = 'pgReload',
  PgLogout = 'pgLogout',
  PgLoginCheck = 'pgLoginCheck',
  PgGameLoaded = 'pgGameLoaded',
  PgChangeGame = 'pgChangeGame',
  PgGetAuthInfo = 'pgGetAuthInfo',
  PgRedirectHome = 'pgRedirectHome',
  PgRedirectLogin = 'pgRedirectLogin',
  PgToggleFullscreen = 'pgToggleFullscreen',
  PgOpenSidebar = 'pgOpenSidebar',
  PgCloseLobby = 'pgCloseLobby',
  PgTournamentFinished = 'tournamentFinished',
  PgTournamentFrameClose = 'tournamentFrameClose',
  PgOpenStream = 'pgOpenStream',
  PgReplayFinish = 'replayFinish',
  PgTrackUserActivity = 'pgTrackUserActivity',
  PgSidebarNotificationClick = 'pgSidebarNotificationClick',
  PgGameLoadFailed = 'pgGameLoadFailed',

  Logout = 'logout',
  Reload = 'reload',
  ExitGame = 'exitGame',
  OpenMenu = 'openMenu',
  WinUpdate = 'winUpdate',
  GameReady = 'gameReady',
  LoginCheck = 'loginCheck',
  GameLoaded = 'gameLoaded',
  GetAuthInfo = 'getAuthInfo',
  StakeUpdate = 'stakeUpdate',
  OpenDeposit = 'openDeposit',
  RoundStarted = 'roundStarted',
  RedirectHome = 'redirectHome',
  ErrorReceived = 'errorReceived',
  RoundFinished = 'roundFinished',
  UpdateSettings = 'updateSettings',
  BalanceUpdated = 'balanceUpdated',
  ActionReceived = 'actionReceived',
  PlayModeUpdate = 'playModeUpdate',
  OpenSlotHistory = 'openSlotHistory',
  AutoPlayStarted = 'autoPlayStarted',
  CloseSlotHistory = 'closeSlotHistory',
  AutoPlayFinished = 'autoPlayFinished',
  JackpotWinUpdate = 'jackpotWinUpdate',
}

// Messages where the sender is Launcher and the receiver is Game
export enum ToGamePostMessage {
  PauseGame = 'pauseGame',
  StopGame = 'stopGame',
  ResumeGame = 'resumeGame',
  OpenHistory = 'openHistory',
  IsBrazilGLA = 'isBrazilGLI',
  OpenPayTable = 'openPaytable',
  ClosePayTable = 'closePaytable',
  TogglePayTable = 'togglePaytable',
  OpenGameHelp = 'openGameHelp',
  CloseGameHelp = 'closeGameHelp',
  ToggleGameHelp = 'toggleGameHelp',
  UpdateBalance = 'updateBalance',
  StopAutoSpins = 'stopAutospins',
  AuthInfoUpdate = 'authInfoUpdate',
  UpdateSettings = 'updateSettings',
  FullscreenChange = 'fullscreenChange',
  ShowSidebarOpener = 'showSidebarOpener',
  TournamentUpdate = 'tournamentUpdate',
  ShowSidebarPromos = 'showSidebarPromos',
  ShowSidebarNotification = 'showSidebarNotification',
}

// Messages where the sender is Parent Frame and the receiver is Launcher
export enum FromParentPostMessage {
  UpdateBalance = 'updateBalance',
  StopAutoSpins = 'stopAutospins',
  ThemeChange = 'themeChange',
  WatchAgain = 'watchAgain'
}

// Messages where the sender is Launcher Frame and the receiver is Parent Frame
export enum ToParentPostMessage {
  ConnectionLost = 'connectionLost',
  OpenStream = 'openStream',
  PgLoaded = 'pgLoaded'
}
